import apiUrl from '../../../../utils/settings';

export const LoginUrl = () => {
  return apiUrl + '/auth/login';
};
export const SendOTPByPhoneUrl = () => {
  return apiUrl + '/auth/send-otp-request-by-user-phone';
};
export const sendOtpForSignUpUrl = () => {
  return apiUrl + '/auth/send-otp-for-sign-up';
};
export const verifySignUpOtpUrl = () => {
  return apiUrl + '/auth/verify-sign-up-otp';
};
export const LoginOtpUrl = () => {
  return apiUrl + '/auth/login-by-otp';
};
export const SetNewPasswordUrl = () => {
  return apiUrl + '/auth/set-new-password';
};
export const RegisterUrl = () => {
  return apiUrl + '/auth/register';
};
export const getOnboardingIndustryUrl = () => {
  return apiUrl + '/onboarding/industry';
};
export const getCompanyAndRoleUrl = () => {
  return apiUrl + '/onboarding/company-and-role';
};
export const getBuyerRolesUrl = () => {
  return apiUrl + '/onboarding/buyer-roles';
};
export const GstUserGstDataFetchUrl = () => {
  return apiUrl + '/user-pan-and-gst/get-gstin-details';
};
export const GstUserPanDataFetchUrl = () => {
  return apiUrl + '/user-pan-and-gst/get-pan-details';
};
export const AllCityUrl = () => {
  return apiUrl + '/onboarding/get/all_district';
};
export const GetMeUrl = () => {
  return apiUrl + '/users/me';
};
export const GetUserFiles = () => {
  return apiUrl + '/users-file/get-id-proof';
};
export const onboardFirmUrl = () => {
  return apiUrl + '/onboarding/firms';
};
export const LogoutUrl = () => {
  return apiUrl + '/auth/logout';
};
export const updateTokenUrl = () => {
  return apiUrl + '/auth/update-token';
};
export const addManufacturerRoleToExistingFirmUrl = () => {
  return apiUrl + '/manufacturer-role-map';
};
export const onboardThroughExistingUserUrl = () => {
  return apiUrl + '/onboarding/through-existing-user';
};
export const getLocationAndPincodeUrl = () => {
  return apiUrl + '/location-and-pincode/by-district';
};

export const getpricingGeographyUrl = () => {
  return apiUrl + '/manufacturer-pricing-geography/pricing-geography';
};
